import createAction from './';

export const SCROLL_RESTORED = createAction('SCROLL_RESTORED');
export const APPOINTMENT_SIZE_UPDATED = createAction('APPOINTMENT_SIZE_UPDATED');

export const scrollRestored = () => ({ type: SCROLL_RESTORED });
export const appointmentSizeUpdated = () => ({ type: APPOINTMENT_SIZE_UPDATED });
